import { getAttrValue, isPlainObject, getLocalizedValue, getLocalizedValues } from "@grandvisionhq/utils";
const getLocalizedAttribute = (variant, attrName, locale, seperator = ", ") => {
  const attrValue = getAttrValue(variant, attrName);
  if (isPlainObject(attrValue)) {
    const obj = attrValue;
    const value = obj?.label ?? attrValue;
    return getLocalizedValue(value, locale);
  }
  if (Array.isArray(attrValue)) {
    return getLocalizedValues(attrValue, locale)?.join(seperator) ?? "";
  }
};
export {
  getLocalizedAttribute
};
//# sourceMappingURL=get-line-item-localized-attribute.js.map
